import { render } from "./Dropdown2.vue?vue&type=template&id=576f90ac"
import script from "./Dropdown2.vue?vue&type=script&lang=js"
export * from "./Dropdown2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__